// extracted by mini-css-extract-plugin
module.exports = {"detailedDescriptionSection":"styles_detailedDescriptionSection__19M9x","title":"styles_title__2rDcz","infoIcon":"styles_infoIcon__2YKDj","description":"styles_description__2VBys"};